
























































































import {
  defineComponent, onMounted, computed, PropType, useContext, ref
} from '@nuxtjs/composition-api';
import {
  SfLink,
  SfButton,
  SfList,
  SfInput,
  SfImage,
  SfIcon,
  SkeletonLoader,
  SfOverlay,
} from '~/components';
import SfBottomModal from './../molecules/SfBottomModal/SfBottomModal.vue';
import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import { StoreConfig } from '~/modules/GraphQL/types';
import { AvailableStores, useStore, useWebsiteCode } from '~/composables';
import countriesList from './../utils/countries-list';


export default defineComponent({
  name: 'StoresModal',
  components: {
    SfButton,
    SfLink,
    SfList,
    SfBottomModal,
    SfInput,
    SfIcon,
    SfImage,
    LoadWhenVisible,
    SkeletonLoader,
    SfOverlay,
  },
  props: {
    isLangModalOpen: Boolean,
    storeConfig: {
      type: Object as PropType<StoreConfig>,
      default: (): StoreConfig => ({}),
    }
  },
  emits: ['closeModal'],
  setup(props, context) {
    const {
      stores,
      change: changeStore,
      load: loadStores,
    } = useStore();
    const { app } = useContext();

    const { isBy } = useWebsiteCode();
    const defaultCountry = isBy.value ? 'Belarus' : 'Russia';
    const defaultCountryCode = isBy.value ? 'belarus' : 'russia';
    const cookieCountry = app.$cookies.get('vsf-selected-country');
    const cookieCountryCode = app.$cookies.get('vsf-selected-country-code');

    if (cookieCountry !== defaultCountry || cookieCountryCode !== defaultCountryCode) {
      app.$cookies.set('vsf-selected-country', defaultCountry);
      app.$cookies.set('vsf-selected-country-code', defaultCountryCode);
    }

    const getShipToCountry = computed(() => app.$cookies.get('vsf-selected-country') || defaultCountry);
    const setShipToCountry = (countryName, countryCode) => {
      app.$cookies.set('vsf-selected-country', countryName);
      app.$cookies.set('vsf-selected-country-code', countryCode);
    };

    const getCurrency = (url, country) => {
      if (country === 'United Arab Emirates') return 'AED';
      const local = url.replace('https://www.togas.com', '')
      switch (local) {
        case '/int/':
          return '€';
        case '/int/en/store-locator/at/':
          return '€';
        case '/us/':
          return '$';
        case '/ae/':
          return 'د.إ.';
        case '/ru/':
          return '₽';
        case '/kz/':
          return '₸';
        case '/lv/':
          return '€';
        case '/cy/':
          return '€';
        default:
          return '';
      }
    };

    const availableStores = computed<AvailableStores>(() => stores.value ?? []);

    onMounted(() => {
      if (stores.value && stores.value?.length) return;
      loadStores();
    });

    const countries = computed(() => countriesList
      .sort((countryCur, countryNext) => countryCur.hasBoutique && countryNext.hasBoutique
        ? 0
        : countryCur.hasBoutique && !countryNext.hasBoutique
          ? -1
          : 1
      )
      .filter(country => country.country.toLowerCase().includes(filterValue.value.toLowerCase()))
    );

    const filterValue =  ref('');

    return {
      availableStores,
      changeStore,
      loadStores,
      countries,
      getShipToCountry,
      getCurrency,
      setShipToCountry,
      filterValue,
    };
  }
});
